export const THOUSAND_SEPARATOR = ' ';
export const TRACE_ID_NAME = 'x-housing-trace-id';
export const EMPTY_VALUE = '—';
